import { create } from 'zustand';
import { LocalStorageUtils } from '@shared';
import { AuthUser } from '@shared/types';

interface IAuthUserStore {
  authUser: AuthUser | undefined;
  setAuthUser: (authUser: AuthUser) => void;
  clear: () => void;
}

export const useAuthUserStore = create<IAuthUserStore>((set) => ({
  authUser: LocalStorageUtils.getIppUser(),

  setAuthUser: (authUser) => set({ authUser }),
  clear: () => set({ authUser: undefined }),
}));
